import { createRouter, createWebHistory } from 'vue-router'
import Home from '@/views/Home.vue'
import Login from '@/views/Login.vue'
import PageNotFound from "@/views/PageNotFound";
import CrudHouse from "@/views/CrudHouse";
import HouseElements from "@/views/HouseElements";
import Report from "@/views/Report";

const routes = [

  {
    path: '/',
    name: 'Home',
    component: Home,
    meta: {title: 'Список домов'}
  },
  {
    path: '/login',
    name: 'Login',
    component: Login,
    meta: {title: 'Авторизация'}
  },
  {
    path: '/add-house',
    name: 'AddHouse',
    component: CrudHouse,
    meta: {title: 'Добавить паспорт дома'}
  },
  {
    path: '/edit-house-:houseId',
    name: 'EditHouse',
    component: CrudHouse,
    meta: {title: 'Редактировать паспорт дома'}
  },
  {
    path: '/house-:houseId',
    name: 'HouseElements',
    component: HouseElements,
    meta: {title: 'Паспорт дома'}
  },
  {
    path: '/report',
    name: 'Report',
    component: Report,
    meta: {title: 'Создание отчета'}
  },
  {
    path: '/:pathMatch(.*)*',
    name: 'PageNotFound',
    component: PageNotFound,
    meta: {title: 'Страница не найдена'}
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
